import React from "react";
import { Form, Image } from "react-bootstrap";
import TimePicker from "rc-time-picker";
import Clock from "../../assets/clock.svg";

const TimePickerField = props => {
  const {
    label,
    className,
    formData,
    isRequiredField,
    onChange,
    name,
    showRequiredError
  } = props;
  return (
    <Form.Group className={`${className}`}>
      <Form.Label>
        {label} {isRequiredField ? <span className="required">*</span> : <></>}
      </Form.Label>
      <div className="form-field">
        <TimePicker
          showSecond={false}
          className={`${
            showRequiredError && formData === "" ? "is-invalid-time-field" : ""
          }`}
          value={formData}
          onChange={event => onChange(event, name)}
          format={"h:mm a"}
          use12Hours
          inputReadOnly
          minuteStep={15}
          allowEmpty={false}
          inputIcon={<Image className="clock-image" src={Clock} />}
        />
      </div>
    </Form.Group>
  );
};
export default TimePickerField;
